var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Amplify } from 'aws-amplify';
import { signOut } from 'aws-amplify/auth';
import { useCallback, useEffect, useReducer } from 'react';
import { Box, LoadingBox, translate, useModal } from '@lucidlink/uicore';
import { useAppUi, useLogOut } from '@lucidlink/workspacemanagement';
import { useDownloadData } from '#context';
import { ConfirmLogoutModal } from './components';
import { LogoutFlowEvents, LogoutFlowStates } from './LogoutFlow.constants';
import { logoutFlowReducer } from './LogoutFlow.reducer';
import styles from './LogoutFlow.module.css';
export const LogoutFlow = () => {
    _react_refresh_temp_2();
    const [state, dispatch] = useReducer(logoutFlowReducer, LogoutFlowStates.Init);
    const { activeDownloads } = useDownloadData();
    const hasActiveDownloads = Boolean(activeDownloads.length);
    const { logoutFlow: { setIsLogoutFlowInProgress }, } = useAppUi();
    const { closeModal: closeLogoutConfirmModal, openModal: openLogoutConfirmModal, } = useModal();
    const closeFlowAction = useCallback(() => {
        setIsLogoutFlowInProgress(false);
        closeLogoutConfirmModal();
    }, [closeLogoutConfirmModal, setIsLogoutFlowInProgress]);
    const confirmLogoutAction = useCallback(() => {
        dispatch(LogoutFlowEvents.Logout);
        closeLogoutConfirmModal();
    }, [closeLogoutConfirmModal]);
    const openConfirmModal = useCallback(() => {
        openLogoutConfirmModal({
            content: (_jsx(ConfirmLogoutModal, { onCancel: closeFlowAction, onConfirm: confirmLogoutAction })),
        });
    }, [closeFlowAction, confirmLogoutAction, openLogoutConfirmModal]);
    const { mutation: { mutate: logOut }, } = useLogOut({
        onSettled: () => dispatch(LogoutFlowEvents.Close),
    });
    useEffect(() => {
        // Close action can be called any time, it will exit the flow and close modals
        if (state === LogoutFlowStates.Close) {
            closeFlowAction();
        }
        else if (state === LogoutFlowStates.Init) {
            dispatch(LogoutFlowEvents.VerifyCanLogout);
        }
        else if (state === LogoutFlowStates.VerifyingCanLogout) {
            if (hasActiveDownloads) {
                dispatch(LogoutFlowEvents.ShowConfirmationModal);
            }
            else {
                dispatch(LogoutFlowEvents.Logout);
            }
        }
        else if (state === LogoutFlowStates.ShowingConfirmationModal) {
            openConfirmModal();
        }
        else if (state === LogoutFlowStates.LoggingOut) {
            logOut();
            /*
             * Sign out from AWS amplify,
             * currently used to login to classic
             * for the FS migration feature.
             *
             * Once we no longer want to migrate
             * users and we deprecate the feature
             * this will be removed.
             *
             * Amplify is configured lazily on Classic login, so we must
             * check that the UserPool is configured before calling signOut.
             */
            if (Amplify.getConfig().Auth?.Cognito?.userPoolId) {
                void signOut();
            }
        }
        else {
        }
    }, [closeFlowAction, hasActiveDownloads, logOut, openConfirmModal, state]);
    return (_jsx(Box, { align: "center", className: styles.SpinnerContainer, isFullHeight: true, isFullWidth: true, justify: "center", orientation: "vertical", children: _jsx(LoadingBox, { alt: translate('Logging out'), className: styles.Spinner, "data-testid": 'log-out-loading-spinner' }) }));
};
_react_refresh_temp_1 = LogoutFlow;
$RefreshReg$(_react_refresh_temp_1, "LogoutFlow");
_react_refresh_temp_2(LogoutFlow, "++oy6t3s2Onl4ratu/0U3HUGG4Q=", false, () => [useDownloadData, useAppUi, useModal, useLogOut]);
